import clsx from 'clsx';
import * as React from 'react';

import { PalettePositionWidth, usePaletteHandle } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';

import { useInsertPageCommands } from '../Page';
import styles from './TableOfContents.module.css';
import { ToCMenuItem } from './ToCMenuItem';

/**
 * Menu item in the TOC to create a new page.
 */
export function NewPageMenuItem() {
    const anchorRef = React.useRef(null);
    const [paletteElement, palette] = useInsertPageCommands();
    const paletteHandle = usePaletteHandle(anchorRef);

    const onPress = () => {
        paletteHandle.open({
            ...palette,
            position: {
                width: PalettePositionWidth.ANCHOR,
                cover: true,
            },
        });
    };

    return (
        <>
            {paletteElement}
            <div className={clsx('mt-4 mr-4 flex border-none', styles.newPageMenuItem)}>
                <ToCMenuItem
                    ref={anchorRef}
                    kind="secondary"
                    icon={Icon.AddNew}
                    onPress={onPress}
                    className="text-ui-base"
                >
                    Add new...
                </ToCMenuItem>
            </div>
        </>
    );
}
